import React, { useState, useEffect, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import EachBusData from "./EachBusData";
import Loading from "./Loading";
import Moment from "react-moment";
import moment from "moment";

import { useHistory } from "react-router-dom";

//import components
import SearchForm from "./SearchForm";
import Calendar from "./Calendar";
import Calendar1 from "./Calendar1";
//import stylesheet
import "./SearchBus.scss";
// API
import { getAllBuses } from "../../../../actions/buses";
import { getAllTrips } from "../../../../actions/trips";
import { getAllOperatorsClient } from "../../../../actions/operators";

// Redux
import { connect } from "react-redux";
import store from "../../../../store";
import language from "../../../../language";
import SelectBtnSection from "./SelectBtnSection";
import SearchPackage from "./SearchPackage";

const SearchBus = ({
  buses: { buses },
  trips: { allTrips },
  operators: { operators },
}) => {
  const history = useHistory();
  const [size, setSize] = useState([0, 0]);
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = React.useState(false);
  const [order, setOrder] = React.useState("price");
  const [order2, setOrder2] = React.useState("price");
  const requestData = useSelector((state) => state?.buses?.requesInfo);
  const departureTripId = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripId
  );
  const departureTripDate = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripDate
  );
  const departureTripRegularId = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripRegularId
  );
  const returnTripRegularId = useSelector(
    (state) => state?.bookings?.bookingInfo?.returnTripRegularId
  );
  const returnTripDate = useSelector(
    (state) => state?.bookings?.bookingInfo?.returnTripDate
  );
  const returnTripId = useSelector(
    (state) => state?.bookings?.bookingInfo?.returnTripId
  );
  const [miniPriceDeparture, setMiniPriceDeparture] = React.useState();
  const [miniPriceReturn, setMiniPriceReturn] = React.useState();
  const [selectedDepartureDate, setSelectedDepartureDate] =
    React.useState(null);
  const [selectedReturnDate, setSelectedReturnDate] = React.useState(null);
  const userData = useSelector((state) => state?.userReducer?.userData?.user);
  const departureTrips = useSelector((state) => state?.trips?.departureTrips);
  const allBuses = useSelector((state) => state?.buses?.buses);
  const allOperators = useSelector((state) => state?.operators?.operators);
  const returnTrips = useSelector((state) => state?.trips?.returnTrips);
  const [inputselectedSeats, setInputSelectedSeats] = useState([1]);
  const reqdata = useSelector((state) => state?.buses?.requesInfo);
  const initialHide = typeof window !== "undefined" && window.innerWidth <= 600;
  const [hideContent, setHideContent] = useState(initialHide);
  const [loaddepartureTrips, setLoaddepartureTrips] = useState(false);
  const [loadReturnTrips, setLoadReturnTrips] = useState(true);
  const oldbooking = useSelector((state) => state?.bookings?.oldBooking);
  const modifyTrip = useSelector(
    (state) => state?.buses?.requesInfo?.modifyTrip
  );

  useEffect(() => {
    setLoaddepartureTrips(false);
  }, [departureTrips]);

  useEffect(() => {
    setLoadReturnTrips(false);
  }, [returnTrips]);

  useEffect(() => {
    let timer;
    if (isLoading) {
      timer = setTimeout(() => {
        setIsLoading(false);
      }, 2000); // 2 seconds
    }
    return () => clearTimeout(timer);
  }, [isLoading]);

  const handleChange = (event) => {
    setOrder(event.target.value);
  };
  const handleChange1 = (event) => {
    setOrder2(event.target.value);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    store.dispatch(getAllBuses());
    store.dispatch(getAllTrips());
    store.dispatch(getAllOperatorsClient());
  }, []);

  function useWindowSize() {
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  useWindowSize();

  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  const ensureArray = (arr) => (Array.isArray(arr) ? arr : []);

  const getFilteredTrips = (trips, id) =>
    ensureArray(trips).filter((eachtrip) => eachtrip._id === id);

  const getTripDetails = (trips) =>
    trips?.map((eachtrip) => {
      const currentBus = eachtrip?.busId;
      const currentOperator = allOperators?.find(
        (operator) => operator?._id === eachtrip?.operatorId
      );
      return {
        trip: eachtrip,
        currentBus,
        currentOperator,
      };
    });

  const sortTrips = (trips, order) =>
    trips?.sort((a, b) => {
      if (order === "earliest") {
        return new Date(a.trip.departureTime) - new Date(b.trip.departureTime);
      } else if (order === "latest") {
        return new Date(b.trip.departureTime) - new Date(a.trip.departureTime);
      } else if (order === "price") {
        const priceDiff = a.trip.price - b.trip.price;
        return priceDiff !== 0
          ? priceDiff
          : new Date(a.trip.departureTime) - new Date(b.trip.departureTime);
      }
      return 0;
    }) || [];

  const sortedTrips1 = sortTrips(getTripDetails(returnTrips), order2);

  const sortedTrips = sortTrips(getTripDetails(departureTrips), order);

  useEffect(() => {
    if (sortedTrips.length > 0) {
      const prices = sortedTrips.map((item) => item.trip.price);
      const minPrice = Math.min(...prices);
      setMiniPriceDeparture(minPrice);
    }
    if (sortedTrips1?.length > 0) {
      const prices = sortedTrips1.map((item) => item.trip.price);
      const minPrice = Math.min(...prices);
      setMiniPriceReturn(minPrice);
    }
  }, [sortedTrips, sortedTrips1]);

  useEffect(() => {
    if (reqdata?.totalPassenger) {
      // Fill array with seat numbers or leave it as empty values (undefined)
      const seatArray = Array.from(
        { length: reqdata.totalPassenger },
        (_, i) => i + 1
      );
      setInputSelectedSeats(seatArray); // Set array with length based on totalPassenger
    }
  }, [reqdata]);

  const ContinueTrip = () => {
    if (!departureTripId || !returnTripId) {
      Swal.fire({
        icon: "error",
        title: "Missing Trips",
        text: "Please select both departure and return trips",
      });
    } else {
      let dataSenderinput = {
        noOfSeats: inputselectedSeats,
        seats: null,
        phone: userData?.phone,
        email: userData?.email,
        price: null,
        // passengerDetails: araydata,
      };

      history.push({
        pathname: "/client/passenger-detail",
        state: dataSenderinput,
      });
    }
  };

  // useEffect(() => {
  //   const handleResize = () => {
  //     // only consider width, ignore height changes
  //     if (window.innerWidth <= 600) {
  //       setHideContent(true);
  //     } else {
  //       setHideContent(false);
  //     }
  //   };

  //   handleResize();
  //   window.addEventListener("resize", handleResize);

  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  // useEffect(() => {
  //   const mediaQuery = window.matchMedia("(max-width: 600px)");
  //   setHideContent(mediaQuery.matches);

  //   const handler = (e) => setHideContent(e.matches);
  //   mediaQuery.addEventListener("change", handler);

  //   return () => mediaQuery.removeEventListener("change", handler);
  // }, []);

  const getFormattedDuration = (departureTime, arrivalTime) => {
    let dep = moment(departureTime, "HH:mm");
    let arr = moment(arrivalTime, "HH:mm");

    if (arr.isBefore(dep)) {
      arr = arr.add(1, "days");
    }

    const duration = moment.duration(arr.diff(dep));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  };

  console.log(sortedTrips, "sortedTrips");

  return (
    <>
      {isLoading ? (
        <div className="result-loading">
          <Loading />
        </div>
      ) : (
        <>
          {(requestData?.tripType === "Round Trip" ||
            requestData?.tripType === "One Way") && (
            <>
              <div className="search-current ">
                <button
                  type="submit"
                  className="form-submit-button inforSectionChange"
                  onClick={() => setHideContent((prevState) => !prevState)}
                >
                  Modify Search
                </button>
                <div style={{ display: hideContent ? "none" : "block" }}>
                  <SearchForm
                    setIsLoading={setIsLoading}
                    setHideContent={setHideContent}
                  />
                </div>
              </div>
              {/* {!departureTripId && ( */}
              <Calendar
                allTrips={allTrips}
                setSelectedDepartureDate={setSelectedDepartureDate}
                route2={requestData?.to}
                route1={requestData?.from}
                Date={requestData?.departureDate}
                miniPriceDeparture={miniPriceDeparture}
                setLoaddepartureTrips={setLoaddepartureTrips}
              />
              {/* )} */}
              <Grid
                container
                className="result"
                justifyContent="space-between"
                style={{ margin: "10px 0" }}
              >
                <Grid
                  item
                  xs={12}
                  align="center"
                  // className={` ${!departureTripId ? "sortingsectionMain" : "sortingsectionMain1"} `}
                  className="sortingsectionMain"
                >
                  {/* {!departureTripId &&  */}
                  <div className="spposeDiv"></div>
                  {/* // } */}
                  <div className="inforHomeOuter">
                    <span className="SelectPackageText">
                      Select your Departure Trip below:
                    </span>
                    <div className="fromtoCity">
                      <span className="to-fro-cities">{requestData?.from}</span>
                      <span className="to-text">To</span>
                      <span className="to-fro-cities">{requestData?.to}</span>
                    </div>
                  </div>
                  {/* {!departureTripId && ( */}
                  <div className="sortingSection">
                    <div className="sortbyText">Sort by</div>
                    <Select
                      value={order}
                      onChange={(e) => handleChange(e)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      className="sortingSelect"
                    >
                      <MenuItem value="earliest">Earliest departure</MenuItem>
                      <MenuItem value="latest">Latest departure</MenuItem>
                      <MenuItem value="price">Price</MenuItem>
                    </Select>
                  </div>
                  {/* // )} */}
                </Grid>
                <Grid
                  item
                  xl={2}
                  lg={2}
                  md={3}
                  sm={12}
                  xs={12}
                  style={{
                    background: "#fff",
                    boxShadow:
                      "2px 2px 8px -3px rgb(0 0 0 / 40%), -2px -2px 8px -3px rgb(0 0 0 / 40%)",
                    padding: "20px",
                    borderRadius: "10px",
                    margin: "30px 0",
                    paddingBottom: "30px",
                  }}
                  className="filterSection"
                >
                  <h2 className="filterTxtHeading">
                    {languageSelectedEnglish ? "Filter" : language.filter}
                  </h2>
                  <h5 className="subHeadingFilter">
                    {languageSelectedEnglish ? "Bus Type" : language.busType}
                  </h5>
                  <Grid item xs={12}>
                    <Grid item xs={12} style={{ margin: "10px 0" }}>
                      <input type="checkbox" />
                      <label
                        style={{ marginLeft: "10px" }}
                        className="filterTypeTxt"
                      >
                        {languageSelectedEnglish
                          ? "Executive Class"
                          : language.executiveClass}
                      </label>
                    </Grid>
                    <Grid item xs={12} style={{ margin: "10px 0" }}>
                      <input type="checkbox" />
                      <label
                        style={{ marginLeft: "10px" }}
                        className="filterTypeTxt"
                      >
                        {languageSelectedEnglish
                          ? "Business Class"
                          : language.businessClass}
                      </label>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <h5
                      style={{ marginTop: "20px" }}
                      className="subHeadingFilter"
                    >
                      {languageSelectedEnglish
                        ? "Operators"
                        : language.operators}
                    </h5>
                    <Grid item xs={12} style={{ margin: "10px 0" }}>
                      <input type="checkbox" />
                      <label
                        style={{ marginLeft: "10px" }}
                        className="filterTypeTxt"
                      >
                        Faisal Movers
                      </label>
                    </Grid>
                    <Grid item xs={12} style={{ margin: "10px 0" }}>
                      <input type="checkbox" />
                      <label
                        style={{ marginLeft: "10px" }}
                        className="filterTypeTxt"
                      >
                        Daewoo Express
                      </label>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xl={9.7}
                  lg={9.7}
                  md={8}
                  sm={12}
                  xs={12}
                  style={{
                    borderRadius: "10px",
                    overflowX: "scroll",
                    margin: "30px 0",
                    gap: "20px",
                    padding: "10px",
                  }}
                  className={`${
                    sortedTrips?.length === 0 ? "tripboxShad" : ""
                  }`}
                >
                  {loaddepartureTrips && (
                    <div className="loaderSection">
                      <CircularProgress sx={{ color: "#c99a3c" }} />
                    </div>
                  )}
                  {!loaddepartureTrips &&
                    (sortedTrips?.length > 0 ? (
                      sortedTrips.map((data, index) => {
                        // ✅ Use helper function
                        const tripDuration = getFormattedDuration(
                          data?.trip?.departureTime,
                          data?.trip?.arrivalTime
                        );

                        return (
                          <Grid
                            item
                            xs={12}
                            sx={{
                              minWidth: { xs: "100%", md: "1000px" },
                              width: { xs: "100%", md: "fit-content" },
                              marginBottom: "20px",
                            }}
                            className="topBusListingSearchedRes"
                          >
                            <Grid container className="ListingWrapper">
                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">
                                    Bus Operator
                                  </p>
                                </div>
                                <div
                                  className="result-each-data-name lowerdescript packageItemsTitles"
                                  flexDirection="column"
                                >
                                  <p className="tripIdp">
                                    {data?.currentOperator?.companyname}
                                  </p>
                                </div>
                              </div>

                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">Trip ID</p>
                                </div>
                                <div
                                  className="result-each-data-name packageItemsTitles"
                                  flexDirection="column"
                                >
                                  <p className="tripIdp">
                                    {data?.trip?.tripAlphaId}
                                  </p>
                                </div>
                              </div>

                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">
                                    {languageSelectedEnglish
                                      ? "Bus Plate Number"
                                      : language.busPlateNumber}
                                  </p>
                                </div>
                                <div className="packageItemsTitles">
                                  <p className="tripIdp">
                                    {data?.currentBus?.busNumber}
                                  </p>
                                </div>
                              </div>

                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">Departure</p>
                                </div>
                                <div
                                  className="result-each-data-departure packageItemsTitles"
                                  flexDirection="column"
                                >
                                  <span className="result-each-data-departure-time dispolayFlexDown">
                                    <div className="tripIdp">
                                      {" "}
                                      {data?.trip?.departureTime}
                                    </div>
                                    <Moment
                                      className="tripIdp"
                                      format="MM/DD/YYYY"
                                    >
                                      {data?.trip?.tripDate
                                        ? data?.trip.tripDate
                                        : selectedDepartureDate}
                                    </Moment>
                                    <span className="result-each-data-departure-place tripIdp">
                                      {data?.trip?.routeFrom}
                                    </span>
                                    <div className="departadress">
                                      {" "}
                                      {data?.trip?.departureAddress}
                                    </div>
                                  </span>
                                </div>
                              </div>

                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">
                                    {languageSelectedEnglish
                                      ? "Duration"
                                      : language.duration}
                                  </p>
                                </div>
                                <div className="packageItemsTitles">
                                  <div className="durationDiv">
                                    <span className="result-each-data-total-time durationp tripIdp">
                                      {tripDuration} hours
                                    </span>

                                    <div className="durationDiv2">
                                      <div className="durationDiv1">
                                        <span className="durationSpan1"></span>
                                        <span className="durationSpan2"></span>
                                      </div>
                                      <AirportShuttleIcon className="busIcon" />
                                      <div className="durationDiv3">
                                        <span className="durationSpan2"></span>
                                        <span className="durationSpan1"></span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">
                                    {languageSelectedEnglish
                                      ? "Arrival"
                                      : language.arrival}
                                  </p>
                                </div>
                                <div
                                  className="result-each-data-arrival packageItemsTitles"
                                  flexDirection="column"
                                >
                                  <span className="result-each-data-arrival-time dispolayFlexDown">
                                    <div className="tripIdp">
                                      {data?.trip?.arrivalTime}
                                    </div>
                                    <Moment
                                      className="tripIdp"
                                      format="MM/DD/YYYY"
                                    >
                                      {data?.trip?.tripDate
                                        ? data?.trip.tripDate
                                        : selectedDepartureDate}
                                    </Moment>
                                    <span className="result-each-data-arrival-place tripIdp">
                                      {data?.trip?.routeTo}
                                    </span>
                                    <div className="departadress">
                                      {" "}
                                      {data?.trip?.arrivalAddress}
                                    </div>
                                  </span>
                                </div>
                              </div>

                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">
                                    {languageSelectedEnglish
                                      ? "Bus Type"
                                      : language.price}
                                  </p>
                                </div>
                                <div className="packageItemsTitles">
                                  <p className="tripIdp">
                                    {data?.currentBus?.busType}
                                  </p>
                                </div>
                              </div>

                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">
                                    {languageSelectedEnglish
                                      ? "Price"
                                      : language.price}
                                  </p>
                                </div>
                                <div className="packageItemsTitles">
                                  <span className="tripIdp priceTextSize">
                                    <span>SAR</span> {data?.trip?.price}
                                  </span>
                                </div>
                              </div>

                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">
                                    {languageSelectedEnglish
                                      ? "Available Seats"
                                      : language.availableSeats}
                                  </p>
                                </div>
                                <div
                                  className="result-each-data-extra packageItemsTitles"
                                  flexDirection="column"
                                >
                                  <span className="result-each-data-extra-available tripIdp">
                                    {data?.trip?.availableSeats}
                                    Available
                                  </span>
                                </div>
                              </div>

                              <div className="eachTripItemOuter">
                                <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                  <p className="headingBusListing">
                                    {languageSelectedEnglish
                                      ? "Baggage Allowance"
                                      : language.theBaggage}
                                  </p>
                                </div>
                                <div
                                  className="result-each-data-extra packageItemsTitles"
                                  flexDirection="column"
                                >
                                  <span className="result-each-data-extra-available tripIdp">
                                    <span className="bold">
                                      {data?.currentBus?.baggage}
                                    </span>{" "}
                                    pieces
                                  </span>
                                </div>
                              </div>
                            </Grid>
                            <SelectBtnSection
                              key={index}
                              trip={data.trip}
                              handleOpenModal={handleOpenModal}
                              bus={data.currentBus}
                              operator={data.currentOperator}
                              selectedDepartureDate={selectedDepartureDate}
                              tripType="Departure"
                              departureTripId={departureTripId}
                              allBuses={allBuses}
                              departureTripDate={departureTripDate}
                              oldbooking={oldbooking} // Pass the oldtripId
                              modifyTrip={modifyTrip}
                            />
                          </Grid>
                        );
                      })
                    ) : (
                      <p>No trips available</p>
                    ))}
                </Grid>
              </Grid>
              {requestData?.tripType === "Round Trip" && (
                <>
                  {/* {!returnTripId && ( */}
                  <Calendar1
                    allTrips={allTrips}
                    setSelectedDepartureDate={setSelectedReturnDate}
                    route2={requestData?.from}
                    route1={requestData?.to}
                    Date={requestData?.returnDate}
                    miniPriceDeparture={miniPriceReturn}
                    setLoadReturnTrips={setLoadReturnTrips}
                  />
                  {/* )} */}
                  <Grid
                    container
                    className="result"
                    justifyContent="space-between"
                    style={{ margin: "10px 0" }}
                  >
                    <Grid
                      item
                      xs={12}
                      align="center"
                      // className={` ${!returnTripId ? "sortingsectionMain" : "sortingsectionMain1"} `}
                      className="sortingsectionMain"
                    >
                      {/* {!returnTripId &&  */}
                      <div></div>
                      {/* } */}
                      <div className="inforHomeOuter">
                        <span className="SelectPackageText">
                          Select your Return Trip below:
                        </span>
                        <div className="fromtoCity">
                          <span className="to-fro-cities">
                            {requestData?.to}
                          </span>
                          <span className="to-text">To</span>
                          <span className="to-fro-cities">
                            {requestData?.from}
                          </span>
                        </div>
                      </div>
                      {/* {!returnTripId && ( */}
                      <div className="sortingSection">
                        <div className="sortbyText">Sort by</div>
                        <Select
                          value={order2}
                          onChange={(e) => handleChange1(e)}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          className="sortingSelect"
                        >
                          <MenuItem value="earliest">
                            Earliest departure
                          </MenuItem>
                          <MenuItem value="latest">Latest departure</MenuItem>
                          <MenuItem value="price">Price</MenuItem>
                        </Select>
                      </div>
                      {/* )} */}
                    </Grid>
                    <Grid
                      item
                      xl={2}
                      lg={2}
                      md={3}
                      sm={12}
                      xs={12}
                      style={{
                        background: "#fff",
                        boxShadow:
                          "2px 2px 8px -3px rgb(0 0 0 / 40%), -2px -2px 8px -3px rgb(0 0 0 / 40%)",
                        padding: "20px",
                        borderRadius: "10px",
                        margin: "30px 0",
                        paddingBottom: "30px",
                      }}
                      className="filterSection"
                    >
                      <h2 className="filterTxtHeading">
                        {languageSelectedEnglish ? "Filter" : language.filter}
                      </h2>
                      <h5 className="subHeadingFilter">
                        {languageSelectedEnglish
                          ? "Bus Type"
                          : language.busType}
                      </h5>
                      <Grid item xs={12}>
                        <Grid item xs={12} style={{ margin: "10px 0" }}>
                          <input type="checkbox" />
                          <label
                            style={{ marginLeft: "10px" }}
                            className="filterTypeTxt"
                          >
                            {languageSelectedEnglish
                              ? "Executive Class"
                              : language.executiveClass}
                          </label>
                        </Grid>
                        <Grid item xs={12} style={{ margin: "10px 0" }}>
                          <input type="checkbox" />
                          <label
                            style={{ marginLeft: "10px" }}
                            className="filterTypeTxt"
                          >
                            {languageSelectedEnglish
                              ? "Business Class"
                              : language.businessClass}
                          </label>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <h5
                          style={{ marginTop: "20px" }}
                          className="subHeadingFilter"
                        >
                          {languageSelectedEnglish
                            ? "Operators"
                            : language.operators}
                        </h5>
                        <Grid item xs={12} style={{ margin: "10px 0" }}>
                          <input type="checkbox" />
                          <label
                            style={{ marginLeft: "10px" }}
                            className="filterTypeTxt"
                          >
                            Faisal Movers
                          </label>
                        </Grid>
                        <Grid item xs={12} style={{ margin: "10px 0" }}>
                          <input type="checkbox" />
                          <label
                            style={{ marginLeft: "10px" }}
                            className="filterTypeTxt"
                          >
                            Daewoo Express
                          </label>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* <Grid
                  item
                  xl={9.7}
                  lg={9.7}
                  md={8}
                  sm={12}
                  xs={12}
                  style={{
                    borderRadius: "10px",
                    overflowX: "scroll",
                    margin: "30px 0",
                    gap: "20px",
                    padding: "10px"
                  }}
                  className={`${sortedTrips1?.length == 0 ? 'tripboxShad' : ''}`}
                >
                  {loadReturnTrips && <div className="loaderSection"><CircularProgress sx={{ color: '#c99a3c' }} /></div>}
                  {!loadReturnTrips &&
                    (sortedTrips1?.length > 0 ? (
                      sortedTrips1.map((data, index) => (
                        <Grid
                          item
                          xs={12}
                          style={{ minWidth: "1000px", width: "fit-content", marginBottom: "20px", }}
                          className="topBusListingSearchedRes"
                        >
                          <Grid
                            container
                            className="ListingWrapper"
                            style={{
                              backgroundColor: "#f5f5f5",
                              borderTop: "1px solid #dee2e6",
                              borderBottom: "1px solid #dee2e6",
                              padding: "10px",
                              display: "flex",
                              flexWrap: "nowrap",
                              alignItems: "center",
                              gap: "10px"
                            }}
                          >
                            <Grid item xs={1} className="Listings packageItemsTitles">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Bus Operator"
                                  : language.operators}
                              </p>
                            </Grid>
                            <Grid item xs={0.8} className="Listings packageItemsTitles">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Trip ID"
                                  : language.operators}
                              </p>
                            </Grid>
                            <Grid item xs={1.2} className="Listings packageItemsTitles">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Departure"
                                  : language.departure}
                              </p>
                            </Grid>
                            <Grid item xs={1.2} className="Listings packageItemsTitles">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Duration"
                                  : language.duration}
                              </p>
                            </Grid>
                            <Grid item xs={1.2} className="Listings packageItemsTitles">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Arrival"
                                  : language.arrival}
                              </p>
                            </Grid>
                            <Grid item xs={0.8} className="Listings packageItemsTitles">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Bus Plate Number"
                                  : language.busPlateNumber}
                              </p>
                            </Grid>
                            <Grid item xs={0.8} className="Listings packageItemsTitles">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Bus Type"
                                  : language.price}
                              </p>
                            </Grid>

                            <Grid item xs={1} className="Listings packageItemsTitlesPrice">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Price"
                                  : language.price}
                              </p>
                            </Grid>
                            <Grid item xs={1} className="Listings packageItemsTitles">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Available Seats"
                                  : language.availableSeats}
                              </p>
                            </Grid>
                            <Grid item xs={1} className="Listings packageItemsTitles">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Baggage Allowance"
                                  : language.theBaggage}
                              </p>
                            </Grid>
                          </Grid>

                          <EachBusData
                            key={index}
                            trip={data.trip}
                            handleOpenModal={handleOpenModal}
                            bus={data.currentBus}
                            operator={data.currentOperator}
                            selectedDepartureDate={selectedReturnDate}
                            tripType="Return"
                            departureTripId={returnTripId}
                            allBuses={allBuses}
                            returnTripDate={returnTripDate}
                            oldbooking={oldbooking}
                            modifyTrip={modifyTrip}
                          />

                        </Grid>
                      ))
                    ) : (
                      <p className="noTripsText">No trips available</p>
                    ))}
                </Grid> */}

                    <Grid
                      item
                      xl={9.7}
                      lg={9.7}
                      md={8}
                      sm={12}
                      xs={12}
                      style={{
                        borderRadius: "10px",
                        overflowX: "scroll",
                        margin: "30px 0",
                        gap: "20px",
                        padding: "10px",
                      }}
                      className={`${
                        sortedTrips1?.length === 0 ? "tripboxShad" : ""
                      }`}
                    >
                      {loadReturnTrips && (
                        <div className="loaderSection">
                          <CircularProgress sx={{ color: "#c99a3c" }} />
                        </div>
                      )}
                      {!loadReturnTrips &&
                        (sortedTrips1?.length > 0 ? (
                          sortedTrips1.map((data, index) => {
                            // ✅ Use helper function
                            const tripDuration = getFormattedDuration(
                              data?.trip?.departureTime,
                              data?.trip?.arrivalTime
                            );

                            return (
                              <Grid
                                item
                                xs={12}
                                sx={{
                                  minWidth: { xs: "100%", md: "1000px" },
                                  width: { xs: "100%", md: "fit-content" },
                                  marginBottom: "20px",
                                }}
                                className="topBusListingSearchedRes"
                              >
                                <Grid container className="ListingWrapper">
                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        Bus Operator
                                      </p>
                                    </div>
                                    <div
                                      className="result-each-data-name lowerdescript packageItemsTitles"
                                      flexDirection="column"
                                    >
                                      <p className="tripIdp">
                                        {data?.currentOperator?.companyname}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        Trip ID
                                      </p>
                                    </div>
                                    <div
                                      className="result-each-data-name packageItemsTitles"
                                      flexDirection="column"
                                    >
                                      <p className="tripIdp">
                                        {data?.trip?.tripAlphaId}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        {languageSelectedEnglish
                                          ? "Bus Plate Number"
                                          : language.busPlateNumber}
                                      </p>
                                    </div>
                                    <div className="packageItemsTitles">
                                      <p className="tripIdp">
                                        {data?.currentBus?.busNumber}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        Departure
                                      </p>
                                    </div>
                                    <div
                                      className="result-each-data-departure packageItemsTitles"
                                      flexDirection="column"
                                    >
                                      <span className="result-each-data-departure-time dispolayFlexDown">
                                        <div className="tripIdp">
                                          {" "}
                                          {data?.trip?.departureTime}
                                        </div>
                                        <Moment
                                          className="tripIdp"
                                          format="MM/DD/YYYY"
                                        >
                                          {data?.trip?.tripDate
                                            ? data?.trip.tripDate
                                            : selectedReturnDate}
                                        </Moment>
                                        <span className="result-each-data-departure-place tripIdp">
                                          {data?.trip?.routeFrom}
                                        </span>
                                        <div className="departadress">
                                          {" "}
                                          {data?.trip?.departureAddress}
                                        </div>
                                      </span>
                                    </div>
                                  </div>

                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        {languageSelectedEnglish
                                          ? "Duration"
                                          : language.duration}
                                      </p>
                                    </div>
                                    <div className="packageItemsTitles">
                                      <div className="durationDiv">
                                        <span className="result-each-data-total-time durationp tripIdp">
                                          {tripDuration} hours
                                        </span>

                                        <div className="durationDiv2">
                                          <div className="durationDiv1">
                                            <span className="durationSpan1"></span>
                                            <span className="durationSpan2"></span>
                                          </div>
                                          <AirportShuttleIcon className="busIcon" />
                                          <div className="durationDiv3">
                                            <span className="durationSpan2"></span>
                                            <span className="durationSpan1"></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        {languageSelectedEnglish
                                          ? "Arrival"
                                          : language.arrival}
                                      </p>
                                    </div>
                                    <div
                                      className="result-each-data-arrival packageItemsTitles"
                                      flexDirection="column"
                                    >
                                      <span className="result-each-data-arrival-time dispolayFlexDown">
                                        <div className="tripIdp">
                                          {data?.trip?.arrivalTime}
                                        </div>
                                        <Moment
                                          className="tripIdp"
                                          format="MM/DD/YYYY"
                                        >
                                          {data?.trip?.tripDate
                                            ? data?.trip.tripDate
                                            : selectedDepartureDate}
                                        </Moment>
                                        <span className="result-each-data-arrival-place tripIdp">
                                          {data?.trip?.routeTo}
                                        </span>
                                        <div className="departadress">
                                          {" "}
                                          {data?.trip?.arrivalAddress}
                                        </div>
                                      </span>
                                    </div>
                                  </div>

                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        {languageSelectedEnglish
                                          ? "Bus Type"
                                          : language.price}
                                      </p>
                                    </div>
                                    <div className="packageItemsTitles">
                                      <p className="tripIdp">
                                        {data?.currentBus?.busType}
                                      </p>
                                    </div>
                                  </div>

                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        {languageSelectedEnglish
                                          ? "Price"
                                          : language.price}
                                      </p>
                                    </div>
                                    <div className="packageItemsTitles">
                                      <span className="tripIdp priceTextSize">
                                        <span>SAR</span> {data?.trip?.price}
                                      </span>
                                    </div>
                                  </div>

                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        {languageSelectedEnglish
                                          ? "Available Seats"
                                          : language.availableSeats}
                                      </p>
                                    </div>
                                    <div
                                      className="result-each-data-extra packageItemsTitles"
                                      flexDirection="column"
                                    >
                                      <span className="result-each-data-extra-available tripIdp">
                                        {data?.trip?.availableSeats}
                                        Available
                                      </span>
                                    </div>
                                  </div>

                                  <div className="eachTripItemOuter">
                                    <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                                      <p className="headingBusListing">
                                        {languageSelectedEnglish
                                          ? "Baggage Allowance"
                                          : language.theBaggage}
                                      </p>
                                    </div>
                                    <div
                                      className="result-each-data-extra packageItemsTitles"
                                      flexDirection="column"
                                    >
                                      <span className="result-each-data-extra-available tripIdp">
                                        <span className="bold">
                                          {data?.currentBus?.baggage}
                                        </span>{" "}
                                        pieces
                                      </span>
                                    </div>
                                  </div>
                                </Grid>
                                <SelectBtnSection
                                  key={index}
                                  trip={data.trip}
                                  handleOpenModal={handleOpenModal}
                                  bus={data.currentBus}
                                  operator={data.currentOperator}
                                  selectedDepartureDate={selectedReturnDate}
                                  tripType="Return"
                                  departureTripId={returnTripId}
                                  allBuses={allBuses}
                                  returnTripDate={returnTripDate}
                                  oldbooking={oldbooking}
                                  modifyTrip={modifyTrip}
                                />
                              </Grid>
                            );
                          })
                        ) : (
                          <p>No trips available</p>
                        ))}
                    </Grid>
                  </Grid>
                </>
              )}
              {requestData?.tripType === "Round Trip" && (
                <div className="continueSection">
                  <button
                    className="contiNuBtn result-each-seats-button"
                    onClick={(e) => ContinueTrip(e)}
                  >
                    CONTINUE
                  </button>
                </div>
              )}
            </>
          )}
          {requestData?.tripType !== "Round Trip" &&
            requestData?.tripType !== "One Way" && <SearchPackage />}
        </>
      )}
    </>
  );
};

SearchBus.propTypes = {};

const mapStateToProps = (state) => ({
  buses: state.buses,
  trips: state.trips,
  operators: state.operators,
});

export default connect(mapStateToProps, null)(SearchBus);
